export function getSelectedValues(filters, options) {
  return (
    options?.filter(option =>
      filters?.some(filter => option.name === filter.name)
    ) ?? []
  );
}
export function getSelectedAttributeValues(filters, options) {
  return (
    options?.filter(option =>
      filters?.some(filter => option.name === filter.name)
    ) ?? []
  );
}

export function mapFilterTypesToFilterArgs(filters, filterTypesToArgsMap) {
  const mappedFilterArgs = {};

  for (const [key, values] of Object.entries(filters)) {
    if (values.length === 0) continue;

    /*
     If we have multiple ids per filter name we need to map these all of these to the args
     (components for example will have multiple ids for one name), otherwise we can just use
     the id for that filter name, since we will only have id per name. We then join all the ids
     if we have multiple filter names (values)
    */

    // Inspect whether the filter key is provided or dynamic(e.g. attribute).
    if (
      filterTypesToArgsMap[key] &&
      ("id" in values[0] || "ids" in values[0])
    ) {
      mappedFilterArgs[
        filterTypesToArgsMap[key]
      ] = values.flatMap(({ id, ids }) => (ids?.length ? ids : [id])).join(",");
    } else if (values.some(value => value?.type === "categorical")) {
      const queryKey = `${formattedAttributeQueryKey(key)}__categorical`;
      mappedFilterArgs[queryKey] = values.map(({ name }) => name);
    } else {
      values.forEach(({ type_name, name }) => {
        mappedFilterArgs[formattedAttributeQueryKey(type_name)] =
          name instanceof Date
            ? Number(Math.round(name.getTime() / 1000).toString())
            : name;
      });
    }
  }
  return mappedFilterArgs;
}

function formattedAttributeQueryKey(type_name) {
  return `attribute_${type_name
    .replaceAll(" ", "_")
    .replace("(", "")
    .replace(")", "")
    .toLowerCase()}`;
}
